/** Юридическая строка внизу каталога (как на onviz.ru, в стиле Liquid Glass). */
export function CatalogLegalFooter() {
  const year = new Date().getFullYear();

  return (
    <footer
      className="px-4 pt-2 pb-2 mt-2"
      aria-label="Реквизиты продавца"
    >
      <div
        className="rounded-2xl px-4 py-3.5"
        style={{
          background: 'rgba(255,255,255,0.04)',
          border: '1px solid var(--border-subtle)',
          boxShadow: '0 0 0 1px rgba(99,179,237,0.04)',
        }}
      >
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2.5 sm:gap-4">
          <p
            className="text-[10px] font-bold uppercase tracking-[0.14em] shrink-0"
            style={{ color: 'var(--text-3)' }}
          >
            Onviz <span style={{ fontWeight: 500, opacity: 0.75 }}>© {year}</span>
          </p>
          <p
            className="text-[10px] leading-snug sm:text-right"
            style={{ color: 'var(--text-2)', fontWeight: 500, letterSpacing: '0.01em' }}
          >
            ИП Семаков Дмитрий Александрович
            <span className="hidden sm:inline" aria-hidden style={{ opacity: 0.35 }}> · </span>
            <span
              className="block sm:inline mt-0.5 sm:mt-0 tabular-nums"
              style={{ color: 'var(--text-3)' }}
            >
              434584728007
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}
